import * as React from "react";
import "../Styles/style.css";
import { useState, useEffect } from "react";
import PostPhotos from "../../images/post-photos.png";
import Redtick from "../../images/Red_tick.png";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { baseUrl } from "../../api/ipconfig";
import TimerLoader from "../../images/timer.gif";
import InputMask from "react-input-mask";
import { AuthContext } from "../../context/AuthContext";
import { v4 as uuidv4 } from "uuid";
import FeatureAdPostBody from "../modals/feature-ad-postbody";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function BikeAd() {
  const { user } = React.useContext(AuthContext);
  const token = localStorage.getItem("token");

  const url = window.location.href;

  const [postToken, setPostToken] = useState(null);

  useEffect(() => {
    const generateToken = () => {
      const newToken = uuidv4().replace(/-/g, "").slice(0, 12);
      setPostToken(newToken);
    };

    generateToken();
  }, []);

  const extractTypeFromUrl = (url) => {
    const parts = url.split("post-ad?");
    return parts.length > 1 ? parts[parts.length - 1] : null;
  };
  const searchCategory = extractTypeFromUrl(url);

  const extractPostIdFromUrl = (url) => {
    const parts = url.split("post-ad/");
    return parts.length > 1 ? parts[parts.length - 1] : null;
  };
  const postRouteId = extractPostIdFromUrl(url);
  const [antiTheftLock, setAntiTheftLock] = useState(false);
  const [diskBrake, setDiskBrake] = useState(false);
  const [ledLight, setLedLight] = useState(false);
  const [windShield, setWindShield] = useState(false);
  const [prevToken, setPrevToken] = useState();
  const [cityName, setCityName] = useState("");
  const [milage, setMilage] = useState("");
  const [price, setPrice] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [makeName, setMakeName] = useState("");
  const [modelName, setModelName] = useState("");
  const [yearName, setYearName] = useState("");
  const [registeredIn, setRegisteredIn] = useState("");
  const [vehicleCondition, setVehicleCondition] = useState("");
  const [vehicleFuel, setVehicleFuel] = useState("");
  const [userName, setUserName] = useState("");
  const [images, setImages] = useState([]);
  const [prevImage, setPrevImage] = useState([]);
  const [typeName, setTypeName] = useState("");
  const [routeId, setRouteId] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [imagesPath, setImagesPath] = useState("");

  const [error, setError] = useState("");
  const [postError, setPostError] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [imageApi, setImageApi] = useState(true);

  const postDisabled = imageApi === false;

  useEffect(() => {
    const type =
      searchCategory === "Free-Ads"
        ? "Free Ads"
        : searchCategory === "Featured-Ads"
        ? "Featured Ads"
        : searchCategory === "Auction-Ads"
        ? "Auction Ads"
        : searchCategory === "Sell-to-fameWheels"
        ? "Sell to fameWheels"
        : "";
    const replicafetchData = localStorage.getItem("data");
    const fetchData = JSON.parse(replicafetchData);
    setUserName(fetchData && fetchData.sub);
    setTypeName(type);
  }, [searchCategory]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (
        cityName ||
        milage ||
        price ||
        phone ||
        description ||
        makeName ||
        modelName ||
        yearName ||
        registeredIn ||
        vehicleCondition ||
        vehicleFuel ||
        userName ||
        images.length > 0
      ) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [
    cityName,
    milage,
    price,
    phone,
    description,
    makeName,
    modelName,
    yearName,
    registeredIn,
    vehicleCondition,
    vehicleFuel,
    userName,
    images,
  ]);

  const [vehicleCategory, setVehicleCategory] = useState(null);
  const [cities, setCities] = useState(null);
  const [make, setMake] = useState(null);
  const [getModel, setGetModel] = useState(null);
  const [makeId, setMakeId] = useState("");
  const [modelYear, setModelYear] = useState(null);
  const [coverImage, setCoverImage] = useState("");

  useEffect(() => {
    const fetchCity = async () => {
      try {
        const response = await axios.get(`${baseUrl}/cities`);

        setCities(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCity();
  }, []);

  // all makes api

  useEffect(() => {
    const fetchMake = async () => {
      try {
        const response = await axios.get(`${baseUrl}/get-bike-makes`);

        setMake(response.data);
        // setOptions(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMake();
  }, []);

  const handleMakeChange = (e) => {
    const selectedMake = make.find(
      (item) => item.bikemake_name === e.target.value
    );
    if (selectedMake) {
      setMakeId(selectedMake.bikemake_id);
    } else {
      setMakeId("");
    }
    setMakeName(e.target.value);
  };

  // all models api

  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axios.get(`${baseUrl}/bike-model-by-make`, {
          params: {
            make_id: makeId,
          },
        });

        setGetModel(response.data);
        // setOptions(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (makeId) {
      fetchModel();
    } else {
      setGetModel([]);
    }
  }, [makeId]);

  // all years api

  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getModelYear`);

        setModelYear(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchYear();
  }, []);

  const history = useHistory();

  const AdSubmit = async (e) => {
    e.preventDefault();
    if (makeId === "") {
      return setPostError("Make is missing"), setPostErrorOpen(true);
    } else if (modelName === "") {
      return setPostError("Model is missing"), setPostErrorOpen(true);
    } else if (yearName === "") {
      return setPostError("Year is missing"), setPostErrorOpen(true);
    } else if (registeredIn === "") {
      return setPostError("Registered In is missing"), setPostErrorOpen(true);
    } else if (cityName === "") {
      return setPostError("City is missing"), setPostErrorOpen(true);
    } else if (milage === "") {
      return setPostError("Milage is missing"), setPostErrorOpen(true);
    } else if (vehicleFuel === "") {
      return setPostError("Vehicle Fuel is missing"), setPostErrorOpen(true);
    } else if (price === "") {
      return setPostError("Price is missing"), setPostErrorOpen(true);
    } else if (description === "") {
      return setPostError("Description missing"), setPostErrorOpen(true);
    } else if (
      (!postRouteId && uploadedImages?.length < 1) ||
      (postRouteId && vehicleImages?.length < 1)
    ) {
      return (
        setPostError("At least one image must be uploaded"),
        setPostErrorOpen(true)
      );
    } else if (!postRouteId && coverImage === "") {
      return setPostError("Select cover image"), setPostErrorOpen(true);
    }
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();

      formData.append("cover", coverImage);
      formData.append("city_id", cityName);
      formData.append("make_id", makeId);
      formData.append("model_id", modelName);
      formData.append("year_id", yearName);
      formData.append("mileage", milage);
      formData.append("engine_type", vehicleFuel);
      formData.append("description", description);
      formData.append("price", price);
      formData.append("mobile", phone);
      formData.append("registered_in", registeredIn);
      formData.append("vehicle_condition", "used");
      formData.append("post_type_id", 1);
      formData.append(`post_token`, prevToken || postToken);

      uploadedImages.forEach((image) => {
        formData.append(`bike_images[]`, image);
      });

      formData.append(
        "features",
        JSON.stringify({
          antiTheftLock,
          diskBrake,
          ledLight,
          windShield,
        })
      );

      if (routeId) {
        formData.append("status", 2);

        const response = await axios.post(`${baseUrl}/updatepost`, formData, {
          params: {
            post_id: postRouteId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        // Open success modal
        setOpenSuccessModal(true);
        setIsSubmitting(false);

        if (typeName === "Sell to fameWheels") {
          setTimeout(() => {
            setOpenSuccessModal(false);
            history.push("/pending-ads");
          }, 3000);
        }
      } else {
        const response = await axios.post(`${baseUrl}/save-bike`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        // Open success modal
        setOpenSuccessModal(true);
        setIsSubmitting(false);

        history.push(`/feature-ad/${response?.data?.post_id}`);

        if (typeName === "Sell to fameWheels") {
          setTimeout(() => {
            setOpenSuccessModal(false);
            history.push("/pending-ads");
          }, 3000);
        }
      }
      const watermarkFormData = new FormData();

      uploadedImages.forEach((image) => {
        watermarkFormData.append(`images[]`, image);
      });
      watermarkFormData.append(`post_type`, "Bike");
      watermarkFormData.append(`post_token`, prevToken || postToken);
      const response = axios.post(
        `${baseUrl}/addwatermark`,
        watermarkFormData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } catch (err) {
      setError(err?.response?.data);
      setPostError(err?.response?.data);
      setPostErrorOpen(true);
      setIsSubmitting(false);
    }
  };

  const [dragging, setDragging] = useState(false);
  const [imageErrorMessage, setImageErrorMessage] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  // upload image preview
  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    setImageApi(false);
    const uploadedImages = [];
    if (images.length + files.length > 20) {
      setImageErrorMessage("Maximum number of images exceeded!");
      setOpen(true);
      return;
    }

    files.forEach((file) => {
      setPrevImage((prevImage) => [...prevImage, file]);
      if (file.size <= 20 * 1024 * 1024) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            const imageSrc = reader.result;
            if (images.length < 20 && !images.includes(imageSrc)) {
              uploadedImages.push(imageSrc);
              setImages((prevImages) => [...prevImages, imageSrc]);
              setImageErrorMessage("");
            } else if (images.includes(imageSrc)) {
              setImageErrorMessage("Duplicate image detected!");
              setOpen(true);
            } else if (images.length > 20) {
              setImageErrorMessage("Maximum number of images exceeded!");
              setOpen(true);
            } else {
              setImageErrorMessage("File size limit exceeded (20MB)!");
              setOpen(true);
            }
          }
        };
        reader.readAsDataURL(file);
      } else {
        setImageErrorMessage("File size limit exceeded (20MB)!");
        setOpen(true);
      }
    });
    for (const image of files) {
      try {
        const formData = new FormData();
        formData.append("imagesList", null);
        formData.append(`post_token`, prevToken || postToken);

        formData.append(`file`, image);
        
        const response = await axios.post(
          `${baseUrl}/save-bike-images`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setUploadedImages((prevImages) => [
          ...prevImages,
          ...response.data.bike_images,
        ]);

        setImagesPath(response.data.imagepath);
        setImageApi(true);
      } catch (error) {
        console.error("image upload Error:", error);
      }
    }
  };

  const handleImageDelete = (index, e) => {
    e.preventDefault();
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);

    uploadedImages.splice(index + 1, 1);
    setUploadedImages(uploadedImages);

    if (newImages.length === 0) {
      setImageErrorMessage("");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);

    const files = Array.from(e.dataTransfer.files);
    const uploadedImages = [];

    files.forEach((file) => {
      if (file.size <= 20 * 1024 * 1024) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            const imageSrc = reader.result;
            if (images.length < 20 && !images.includes(imageSrc)) {
              uploadedImages.push(imageSrc);
              setImages((prevImages) => [...prevImages, imageSrc]);
              setImageErrorMessage("");
            } else if (images.includes(imageSrc)) {
              setImageErrorMessage("Duplicate image detected!");
              setOpen(true);
            } else {
              setImageErrorMessage("Maximum number of images exceeded!");
              setOpen(true);
            }
          }
        };
        reader.readAsDataURL(file);
      } else {
        setImageErrorMessage("File size limit exceeded (20MB)!");
        setOpen(true);
      }
    });
  };

  const [vehicleImages, setVehicleImages] = useState(null);
  const fetchImages = async () => {
    try {
      const response = await axios.get(`${baseUrl}/postimages`, {
        params: {
          post_id: prevToken,
        },
      });

      setVehicleImages(response?.data?.images);
      setImagesPath(response?.data?.imagepath);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (prevToken) {
      fetchImages();
    }
  }, [prevToken]);

  useEffect(() => {
    if (postRouteId) {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${baseUrl}/vehicle-details`, {
            params: {
              post_id: postRouteId,
              userId: user?.id,
            },
          });

          const {
            post_token,

            city_id,

            milage,
            price,
            phone,
            description,
            makeName,
            make_id,
            model_id,
            year_id,
            registered_in,

            vehicleCondition,
            vehicle_fuel,
            userName,
            post_id,
            engine_capacity,
            car_features,
          } = response.data;
          setPrevToken(post_token);

          setCityName(city_id);

          setMilage(milage);
          setPrice(price);
          setPhone(phone);
          setDescription(description);
          setMakeName(makeName);
          setMakeId(make_id);
          setModelName(model_id);
          setYearName(year_id);
          setRegisteredIn(registered_in);

          setVehicleCondition(vehicleCondition);
          setVehicleFuel(vehicle_fuel);
          setUserName(userName);
          setRouteId(post_id);

          const carFeatures = JSON.parse(car_features);

          setVehicleFuel(carFeatures?.vehicle_fuel);
          setAntiTheftLock(carFeatures?.power_mirrors);
          setDiskBrake(carFeatures?.power_steering);
          setLedLight(carFeatures?.power_windows);
          setWindShield(carFeatures?.rear_ac_vents);

          const fetchData = async () => {
            try {
              const response = await axios.get(`${baseUrl}/bycategory`);

              setVehicleCategory(response.data);
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };

          fetchData();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [postRouteId]);

  const updateImageDelete = async (index, image) => {
    try {
      await axios.delete(`${baseUrl}/deleteImages`, {
        params: {
          user_id: user?.id,
          post_id: postRouteId,
          filename: image,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      fetchImages();
      setImageApi(true);
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const [postErrOpen, setPostErrorOpen] = React.useState(false);

  const handlePostClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setPostErrorOpen(false);
  };

  const onClose = () => {
    setOpenSuccessModal(false);
  };

  return (
    <>
      <Snackbar
        open={postErrOpen}
        autoHideDuration={6000}
        onClose={handleBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handlePostClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {postError}
        </Alert>
      </Snackbar>
      <div>
        <div className="container mb-5">
          <div className="postInform p-5">
            <div className="text-center">
              <h4>Bike Information</h4>
              <h6>(All fields marked with * are mandatory)</h6>
            </div>
            <form onSubmit={AdSubmit} className="postAdForm">
              {error && <p>{error}</p>}

              <div
                className={`dropzone text-center my-5 ${
                  dragging ? "dragging" : ""
                }`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <div>
                  <img src={PostPhotos} alt="car photo" srcSet={PostPhotos} />
                </div>
                <Button
                  variant="text"
                  component="label"
                  className="vehcileImages_uploadBtn"
                  sx={{ textTransform: "capitalize" }}
                >
                  <AddAPhotoIcon className="me-2" /> Add Photos
                  <input
                    name="vehicleImages"
                    hidden
                    className="form-control"
                    id="vehicleImages"
                    accept=".jpg,.jpeg,.png,"
                    multiple
                    onChange={handleImageUpload}
                    type="file"
                  />
                </Button>
                <p className="vImgLimit">(Max limit 20 MB per image)</p>
                <p className="dropHere">
                  {" "}
                  <AddIcon sx={{ fontSize: 40 }} /> Drop here
                </p>

                <Snackbar
                  open={open}
                  autoHideDuration={6000}
                  onClose={handleBarClose}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <Alert
                    onClose={handleBarClose}
                    severity="error"
                    sx={{ width: "100%" }}
                  >
                    {imageErrorMessage}
                  </Alert>
                </Snackbar>
                <div className="previewMain">
                  {images.map((image, index) => (
                    <div key={index} className="vehicleImagePreview">
                      <img src={image} alt={`Preview ${index + 1}`} />
                      <button
                        className="btn"
                        onClick={(e) => handleImageDelete(index, e)}
                      >
                        <ClearIcon sx={{ color: "#ffffff", fontSize: 18 }} />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="previewMain">
                  {vehicleImages &&
                    vehicleImages?.map((image, index) => (
                      <div key={index} className="vehicleImagePreview">
                        <img
                          src={`${imagesPath}/${prevToken}/${image?.filename}`}
                          alt={`Preview ${index + 1}`}
                        />
                        <button
                          className="btn"
                          type="submit"
                          onClick={() =>
                            updateImageDelete(index, image?.filename)
                          }
                        >
                          <ClearIcon sx={{ color: "#ffffff", fontSize: 18 }} />
                        </button>
                      </div>
                    ))}
                </div>
                <div className="row pt-5 d-none d-md-flex ">
                  <div className="col-lg-4 col-12 uploadImage_inst">
                    <img src={Redtick} alt="tick" srcSet={Redtick} />
                    <p>
                      Adding at least 8 pictures improves the chances for a
                      quick sale.
                    </p>
                  </div>
                  <div className="col-lg-4 col-12 uploadImage_inst">
                    <img src={Redtick} alt="tick" srcSet={Redtick} />
                    <p>
                      Adding clear Front, Back and Interior pictures of your car
                      increases the quality of your Ad and gets you noticed
                      more.
                    </p>
                  </div>
                  <div className="col-lg-4 col-12 uploadImage_inst">
                    <img src={Redtick} alt="tick" srcSet={Redtick} />
                    <p>Photos should be in 'jpeg, jpg, png' format only.</p>
                  </div>
                </div>

                {uploadedImages?.length > 0 && <h5>Select Cover Image</h5>}

                <div className="previewMain">
                  {uploadedImages &&
                    uploadedImages?.map((image, index) => (
                      <div
                        key={index}
                        className="vehicleImagePreviewCover form-check form-check-inline md-radioStyle p-0"
                      >
                        <input
                          id={`coverImage${index}`}
                          name="coverImage"
                          type="radio"
                          className="border-2 border-gray-200 outline-red-500 w-full p-1 rounded text-sm form-check-input radio-input"
                          onChange={() => setCoverImage(image)}
                        />
                        <label
                          className="form-check-label radio-label"
                          htmlFor={`coverImage${index}`}
                        >
                          <img
                            src={`${imagesPath}/${
                              prevToken || postToken
                            }/${image}`}
                            alt={`Preview ${index + 1}`}
                          />
                        </label>
                      </div>
                    ))}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="mb-3">
                    <label for="vehicleMake" className="form-label">
                      Make
                    </label>
                    <select
                      className="form-select"
                      id="vehicleMake"
                      aria-label="Default select example"
                      required
                      value={makeName}
                      onChange={handleMakeChange}
                    >
                      <option selected value=" ">
                        Select Make
                      </option>
                      {make &&
                        make.map((item) => (
                          <option
                            key={item.bikemake_id}
                            value={item.bikemake_name}
                          >
                            {item.bikemake_name}
                          </option>
                        ))}
                    </select>
                    <div id="CityHelp" className="form-text">
                      Mention your vehicle's make (e.g. Honda)
                    </div>
                  </div>
                </div>
                {makeName !== " " && (
                  <div className="col-lg-3 col-md-6 col-12">
                    {makeId && getModel?.length > 0 ? (
                      <div className="mb-3">
                        <label for="vehicleModel" className="form-label">
                          Model
                        </label>
                        <select
                          className="form-select"
                          id="vehicleModel"
                          aria-label="Default select example"
                          required
                          value={modelName}
                          onChange={(e) => setModelName(e.target.value)}
                        >
                          <option selected value=" ">
                            Select {makeName && makeName} Model
                          </option>
                          {getModel &&
                            getModel.map((item) => (
                              <option
                                key={item.bikemodel_id}
                                value={item.bikemodel_id}
                              >
                                {item.bikemodel_name}
                              </option>
                            ))}
                        </select>

                        <div id="CityHelp" className="form-text">
                          Mention your vehicle's Model (e.g. Civic)
                        </div>
                      </div>
                    ) : (
                      <div className="mb-3">
                        <label for="vehicleModel" className="form-label">
                          Model
                        </label>
                        <select
                          className="form-select border-danger"
                          id="vehicleModel"
                          aria-label="Default select example"
                          required
                          disabled
                        >
                          <option selected value=" ">
                            Select {makeName && makeName} Model
                          </option>
                        </select>

                        <div id="CityHelp" className="form-text text-danger">
                          Select make first
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {modelName && modelName !== " " && (
                  <div className="col-lg-3 col-md-6 col-12">
                    {makeId && modelName !== " " && modelYear?.length > 0 ? (
                      <div className="mb-3">
                        <label for="vehicleYear" className="form-label">
                          Year
                        </label>
                        <select
                          className="form-select"
                          id="vehicleYear"
                          aria-label="Default select example"
                          required
                          value={yearName}
                          onChange={(e) => setYearName(e.target.value)}
                        >
                          <option selected value=" ">
                            Select {modelName && modelName} Year
                          </option>
                          {modelYear &&
                            modelYear.map((item) => (
                              <option key={item.yearId} value={item.yearId}>
                                {item.year}
                              </option>
                            ))}
                        </select>

                        <div id="CityHelp" className="form-text">
                          Mention your vehicle's Year (e.g. 2018)
                        </div>
                      </div>
                    ) : (
                      <div className="mb-3">
                        <label for="vehicleYear" className="form-label">
                          Year
                        </label>
                        <select
                          className="form-select border-danger"
                          id="vehicleYear"
                          aria-label="Default select example"
                          required
                          disabled
                        >
                          <option selected value=" ">
                            Select Year
                          </option>
                        </select>
                        <div id="CityHelp" className="form-text text-danger">
                          Select Model first
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="col-lg-3 col-md-6 col-12">
                  <div className="mb-3">
                    <label for="post-registeration" className="form-label">
                      Registered In
                    </label>
                    <select
                      className="form-select"
                      id="post-registeration"
                      aria-label="Default select example"
                      required
                      placeholder="Registered In"
                      value={registeredIn}
                      onChange={(e) => setRegisteredIn(e.target.value)}
                    >
                      <option selected value=" ">
                        Select
                      </option>
                      <option value="Unregistered">Unregistered</option>
                      <option value="Islamabad">Islamabad</option>
                      <option value="Sindh">Sindh</option>
                      <option value="Punjab">Punjab</option>
                      <option value="KPK">KPK</option>
                      <option value="Balochistan">Balochistan</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="mb-3">
                    <label for="post-city" className="form-label">
                      City
                    </label>
                    <select
                      className="form-select"
                      id="post-city"
                      aria-label="Default select example"
                      required
                      value={cityName}
                      onChange={(e) => setCityName(e.target.value)}
                    >
                      <option selected value=" ">
                        Select City
                      </option>
                      {cities &&
                        cities.map((item) => (
                          <option key={item?.cityID} value={item.cityID}>
                            {item.cityName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div>
                    <label for="vehicleKM" className="form-label">
                      Mileage * (km)
                    </label>
                    <div className="input-group">
                      <input
                        type="number"
                        className="form-control"
                        id="vehicleKM"
                        placeholder="Mileage"
                        min="0"
                        required
                        value={milage}
                        onChange={(e) => setMilage(e.target.value)}
                      />
                      <span
                        className="input-group-text text-white"
                        id="basic-addon2"
                      >
                        KM
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="mb-3">
                    <label for="post-registeration" className="form-label">
                      Vehicle Fuel
                    </label>
                    <div className="d-flex justify-content-start flex-wrap">
                      <div className="form-check form-check-inline md-radioStyle p-0">
                        <input
                          className="form-check-input radio-input"
                          type="radio"
                          name="vehicleFuel"
                          id="vehicle2Stroke"
                          value="2 Stroke"
                          checked={vehicleFuel === "2 Stroke"}
                          onChange={(e) => setVehicleFuel(e.target.value)}
                        />
                        <label
                          className="form-check-label radio-label"
                          for="vehicle2Stroke"
                        >
                          2 Stroke
                        </label>
                      </div>
                      <div className="form-check form-check-inline md-radioStyle p-0">
                        <input
                          className="form-check-input radio-input"
                          type="radio"
                          name="vehicleFuel"
                          id="vehicle4Stroke"
                          value="4 Stroke"
                          checked={vehicleFuel === "4 Stroke"}
                          onChange={(e) => setVehicleFuel(e.target.value)}
                        />
                        <label
                          className="form-check-label radio-label"
                          for="vehicle4Stroke"
                        >
                          4 Stroke
                        </label>
                      </div>

                      <div className="form-check form-check-inline md-radioStyle p-0">
                        <input
                          className="form-check-input radio-input"
                          type="radio"
                          name="vehicleFuel"
                          id="vehicleElectric"
                          value="Electric"
                          checked={vehicleFuel === "Electric"}
                          onChange={(e) => setVehicleFuel(e.target.value)}
                        />
                        <label
                          className="form-check-label radio-label"
                          for="vehicleElectric"
                        >
                          Electric
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div>
                    <label for="postPrice" className="form-label">
                      Price* (PKR.)
                    </label>
                    <div className="input-group">
                      <input
                        type="number"
                        className="form-control"
                        id="postPrice"
                        placeholder="Price"
                        min="1000"
                        required
                        aria-describedby="vehiclePrice"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                      />
                      <span
                        className="input-group-text text-white"
                        id="basic-addon2"
                      >
                        PKR
                      </span>
                    </div>
                    <div
                      id="vehiclePrice"
                      className="form-text"
                      style={{ height: 25, textTransform: "capitalize" }}
                    >
                      {formatPrice(price)}
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-12 mb-5">
                  <label for="vehicleDescription" className="form-label">
                    Ad Description *
                  </label>
                  <textarea
                    className="form-control"
                    id="vehicleDescription"
                    aria-describedby="vehicleDescription"
                    required
                    rows="5"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                  <div id="vehicleDescription" className="form-text">
                    Describe Your Bike: <br></br>
                    Example: Alloy rim, first owner, genuine parts, maintained
                    by authorized workshop, excellent mileage, etc.
                  </div>
                </div>

                <div className="col-lg-12 col-12">
                  <h6 className="fs-5 fw-700">Features</h6>
                </div>

                <div className="col-lg-2 col-4">
                  <label
                    for="featurecheck"
                    className="form-label customCheck_label"
                  >
                    Anti Theft Lock
                  </label>
                  <div className="PostSwitch form-check form-switch d-flex gap-3 align-items-center  ">
                    <input
                      className="form-check-input "
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={antiTheftLock === "true"}
                      onChange={(e) =>
                        setAntiTheftLock(e.target.checked ? "true" : "false")
                      }
                    />
                    <label
                      className="form-check-label PostSwitch_label"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {antiTheftLock === "true" ? "Yes" : "No"}
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-4">
                  <label
                    for="featurecheck"
                    className="form-label customCheck_label"
                  >
                    Disc Brake
                  </label>
                  <div className="PostSwitch form-check form-switch d-flex gap-3 align-items-center  ">
                    <input
                      className="form-check-input "
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={diskBrake === "true"}
                      onChange={(e) =>
                        setDiskBrake(e.target.checked ? "true" : "false")
                      }
                    />
                    <label
                      className="form-check-label PostSwitch_label"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {diskBrake === "true" ? "Yes" : "No"}
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-4">
                  <label
                    for="featurecheck"
                    className="form-label customCheck_label"
                  >
                    Led Light
                  </label>
                  <div className="PostSwitch form-check form-switch d-flex gap-3 align-items-center  ">
                    <input
                      className="form-check-input "
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={ledLight === "true"}
                      onChange={(e) =>
                        setLedLight(e.target.checked ? "true" : "false")
                      }
                    />
                    <label
                      className="form-check-label PostSwitch_label"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {ledLight === "true" ? "Yes" : "No"}
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-4">
                  <label
                    for="featurecheck"
                    className="form-label customCheck_label"
                  >
                    Wind Shield
                  </label>
                  <div className="PostSwitch form-check form-switch d-flex gap-3 align-items-center  ">
                    <input
                      className="form-check-input "
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={windShield === "true"}
                      onChange={(e) =>
                        setWindShield(e.target.checked ? "true" : "false")
                      }
                    />
                    <label
                      className="form-check-label PostSwitch_label"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {windShield === "true" ? "Yes" : "No"}
                    </label>
                  </div>
                </div>
              </div>

              <div className="text-center pt-5 ">
                <h4 className="pb-3">Contact Information</h4>
              </div>
              <div className="row mb-3">
                <div className="col-lg-6 col-12">
                  <div className="mb-3">
                    <label for="posterMobileNumber" className="form-label">
                      Mobile Number *
                    </label>
                    <InputMask
                      mask="03999999999"
                      maskChar={null}
                      type="text"
                      className="form-control"
                      id="posterMobileNumber"
                      aria-describedby="MobileNumberHelp"
                      placeholder="Enter Your Mobile Number"
                      required
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    <div id="MobileNumberHelp" className="form-text">
                      Enter a genuine 11 digit mobile no. with format
                      03XXXXXXXXX. <br></br> All inquires will come on this
                      number.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="mb-3">
                    <label for="posterMobileSecond" className="form-label">
                      Secondary Mobile Number (Optional)
                    </label>
                    <InputMask
                      mask="99999999999"
                      maskChar={null}
                      type="text"
                      className="form-control"
                      id="posterMobileNumber"
                      aria-describedby="MobileNumberHelp"
                      placeholder="Secondary Mobile Number"
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3 form-check md-radioStyle2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="exampleCheck1"
                  required
                />
                <label className="form-check-label" for="exampleCheck1">
                  I accept above given information is correct
                </label>
                <div className="form-text">
                  In case of any false information your Ad will be rejected!
                </div>
              </div>
              <div className="text-center pt-3">
                <button
                  type="submit"
                  className="btn fw-secondary postFormBtn"
                  disabled={postDisabled}
                  style={
                    postDisabled
                      ? { backgroundColor: "#b8050550" }
                      : { backgroundColor: "#b80505" }
                  }
                >
                  {postDisabled ? "Complete to continue" : "Post"}
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* post */}

        {/* submitting modal */}

        <Modal
          open={isSubmitting}
          onClose={() => setIsSubmitting(false)}
          disableAutoFocus={true}
          className="timerModal"
        >
          <Box className="text-center successModal " sx={successModal}>
            <img
              className="modalLoaderImg"
              src={TimerLoader}
              alt="Loading..."
              srcSet=""
            />
          </Box>
        </Modal>

        <FeatureAdPostBody
          open={openSuccessModal}
          onClose={onClose}
          typeName={typeName}
        />
      </div>
    </>
  );
}
